import i18n from '@/i18n';
import { getToken } from '@nxtpeople/nxt-vue-keycloak';
import axios, { AxiosResponse } from 'axios';
import router from '../router';
import store from '../store';

const authRequestInterceptor = async function (config: any) {
   const token = await getToken();
   config.headers = {
      ...config.headers,
      Authorization: `Bearer ${token}`,
      Accept: `application/json`,
   };

   return config;
};

const authResponseSuccessInterceptors = async function (response: AxiosResponse) {
   return response;
};

const authResponseErrorInterceptors = async function (error: any) {
   if (axios.isCancel(error)) return await Promise.reject(error);

   if (!error?.response) {
      router.push({
         path: '/error',
         query: {
            error_code: i18n.global.t('error'),
            error_title: i18n.global.t('something-went-wrong'),
            error_message: `${store.state.isDev ? `${JSON.stringify(error)}` : i18n.global.t('contact-support')}`,
            error_action: 'refresh',
         },
      });

      return await Promise.reject(error);
   }

   const { status, headers, config } = error.response;

   if (status === 401) {
      router.push({
         path: '/error',
         query: {
            error_code: '401',
            error_title: i18n.global.t('account-not-found'),
            error_message: `${store.state.isDev ? `${JSON.stringify(error)}` : i18n.global.t('account-not-found-description')}`,
            error_action: 'logout',
         },
      });
   }

   if (status === 403 && !headers?.location && config?.method === 'get') {
      router.push({
         path: '/error',
         query: {
            error_code: '403',
            error_title: i18n.global.t('access-denied'),
            error_message: `${store.state.isDev ? `${JSON.stringify(error)}` : i18n.global.t('u-have-no-access')}`,
            error_action: 'home-or-logout',
         },
      });
   }

   return await Promise.reject(error);
};

export { authRequestInterceptor, authResponseErrorInterceptors, authResponseSuccessInterceptors };
